/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/DirektTeaser/theme';

export const DirektTeaserTheme = theme;
